import idlImport from './marketplace_canister.did.js';
export const idlFactory = idlImport;
export const canisterId = "k2zxd-3iaaa-aaaab-qabha-cai";
